<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>القرى</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div v-show="$per.value.saveRegions" class='panel-heading'>
                              هنا يتم عرض جميع القرى
                                <div class='pull-left' style='padding=0px'>
                                    <button @click='showForm(0)' type='button' class='btn btn-outline btn-primary btn-sm ' style='padding:3px;width: 80px' data-toggle='modal' data-target='#myModal'>
                                      <b>  إضافة جديد </b>
                                    </button>
                                </div>
                              </div>
                              <div class='form-group col-lg-3 col-sm-3'>
                                <h4 >الفرع:</h4>
                                <select @change='FillItineraries()' class="form-control" v-model="branche">
                                  <option v-for="item in branches" :key="item.id" v-bind:value="item.id">
                                    {{ item.name }}
                                  </option>
                                </select>
                              </div>
                              <div class='form-group col-lg-3 col-sm-3'>
                                <h4 >الخط:</h4>
                                <select @change='FillRegions()' class="form-control" v-model="itinerary">
                                  <option v-for="item in itineraries" :key="item.id" v-bind:value="item.id">
                                    {{ item.name }}
                                  </option>
                                </select>
                              </div>
                              <div class='form-group col-lg-3 col-sm-3'>
                                <h4 >المنطقة:</h4>
                                <select class="form-control" v-model="region">
                                  <option v-for="item in regions" :key="item.id" v-bind:value="item.id">
                                    {{ item.region_name }}
                                  </option>
                                </select>
                              </div>
                              <div class='form-group col-lg-3 col-sm-3' style="padding-top:10px">
                                <label>&nbsp;</label>
                                <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-lg btn-block' style='padding:3px'>
                                  <b> عرض </b>
                                </button>
                              </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                    <thead>
                                      <tr>
                                        <th style='text-align: center'>م</th>
                                        <th style='text-align: center'>الخط</th>
                                        <th style='text-align: center'>المنطقة</th>
                                          <th style='text-align: center'>القرية</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                        <tr class='odd gradeX' v-for='(record, index) in records' :key='record.id'>

                                          <td align='center'>{{index +1}}</td>
                                          <td align='center'>{{record.name}}</td>
                                          <td align='center'>{{record.region_name}}</td>
                                          <td align='center'>{{record.village}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- /.table-responsive -->
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- Modal -->
             <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
                 <div class='modal-dialog  modal-lg'>
                     <div class='modal-content'>
                         <div class='modal-header'>
                             <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
                             <h4 class='modal-title' id='myModalLabel'>{{title}}</h4>
                         </div>
                         <form role='form'>
                         <div class='modal-body'>
                           <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                             <ul v-if='validationErrors'>
                                 <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                             </ul>
                           </div>
                           <div class='alert alert-success alert-dismissable' v-if='successShow'>
                              {{success}}
                           </div>
                           <fieldset>
                                 <div class='form-group col-lg-6 col-sm-6'>
                                   <label>الخط:</label>
                                     <select class="form-control" v-model="record.itinerary_id">
                                       <option v-for="item in itineraries" :key="item.id" v-bind:value="item.id">
                                         {{ item.name }}
                                       </option>
                                     </select>
                                 </div>
                                 <div class='form-group col-lg-6 col-sm-6'>
                                     <label>المنطقة:</label>
                                     <input v-model='record.region_name' class='form-control' name='region_name' type='text'>
                                 </div>
                               </fieldset>
                           </div>
                           <div class='modal-footer'>
                               <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
                               <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                               <button @click='saveData' type='button' class='btn btn-primary'>حفظ</button>
                           </div>
                         </form>
                     </div>
                     <!-- /.modal-content -->
                 </div>
                 <!-- /.modal-dialog -->
             </div>
             <!-- /.modal -->
             <!-- /.container-fluid -->
        </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'Villages',
  data () {
    return {
      emptyRec: [{id: 0, name: 0}],
      validationErrors: '',
      records: {},
      record: {},
      regions: '',
      region: '',
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      branches: [],
      branche: '',
      itineraries: [],
      itinerary: '',
      title: ''
    }
  },
  created () {
    this.branche = localStorage.getItem('BrancheID')
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.FillItineraries(this.branche)
  },
  methods: {
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-villages', {
        token: localStorage.getItem('token'),
        itinerary_id: this.itinerary,
        branch_id: this.branche,
        region_id: this.region
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    // =================================================
    FillItineraries () {
      let i = this.branches.findIndex(x => x.id === parseInt(this.branche))
      if (i > -1) {
        this.itineraries = JSON.parse(JSON.stringify(this.branches[i].itineraries))
        this.itineraries.unshift(this.emptyRec)
      }
    },
    // =================================================
    FillRegions () {
      let r = this.branches.findIndex(x => x.id === parseInt(this.branche))
      if (r > -1) {
        let i = this.branches[r].itineraries.findIndex(x => x.id === parseInt(this.itinerary))
        if (i > -1) {
          this.regions = JSON.parse(JSON.stringify(this.branches[r].itineraries[i].regions))
          this.regions.unshift(this.emptyRec)
        }
      }
    },
    // =================================================
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.error = ''
      if (recID === 0) {
        this.title = 'إضافة سجل جديد'
        this.record = {'id': 0, 'itinerary_id': '', 'region_name': ''}
      } else {
        this.title = 'تعديل بيانات سجل'
        this.record = {'id': recID.id, 'itinerary_id': recID.itinerary_id, 'region_name': recID.region_name}
      }
    },
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveRegions', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        itinerary_id: this.record.itinerary_id,
        region_name: this.record.region_name
      })
        .then(res => {
          this.isLoadingSave = false
          if (this.record.id === 0) {
            this.records.push(res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          } else {
            let i = this.records.map(record => record.id).indexOf(this.record.id)
            this.records.splice(i, 1, res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    deleteData (recID) {
      this.isLoadingDelete = true
      axios.post(this.$apiURL + 'deleteRegions', {
        token: localStorage.getItem('token'),
        id: recID
      })
        .then(res => {
          let i = this.records.map(record => record.id).indexOf(recID)
          this.records.splice(i, 1)
          this.isLoadingDelete = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.error = err.message
          this.isLoadingDelete = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/company/Villages.vue